// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Vvet+","common":"styles_common__Fw6vc","empty":"styles_empty__zRFGt"};